// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"595":"b9c0b1e7","872":"3c527952"}[chunkId] + ".chunk.js";
};